export type CupGenerationWinners = {
  year: number;
  gold: string;
  silver: string;
  bronze: string;
};

/** Finalni plasman po generacijama — Junior Cup 2026 (maj). */
export const CUP_WINNERS_2026: CupGenerationWinners[] = [
  { year: 2019, gold: 'Crvena Zvezda BG', silver: 'Bolesnikov NS', bronze: 'Bistrica NS' },
  { year: 2018, gold: 'GDM NS', silver: 'Bambi ZR', bronze: 'Feniks NS' },
  { year: 2017, gold: 'Vojvodina NS', silver: 'Meridiana NS', bronze: 'Junior NS' },
  { year: 2016, gold: 'Vojvodina NS', silver: 'Junior Crveni NS', bronze: 'Derby A NS' },
  { year: 2015, gold: 'Slavija NS', silver: 'Radnički SM', bronze: 'Varga BG' },
  { year: 2014, gold: 'Tiento Futog', silver: 'Radnički SM', bronze: 'Vošini Klinci NS' },
];
